import { Expression, SqlOptions } from '../../types';
import dateFormatter from './date-formatter';
import { findColumn, findColumnName } from '../find-column';
import statusFormatter from './status-formatter';
import stringFormatter from './string-formatter';
import expressionFormatter from './expression-formatter';

export default function formatExpression(
  sqlOptions: SqlOptions, expression: Expression,
): Expression | null {
  const { field } = expression;
  const column = findColumn(sqlOptions, field);

  const reportUnfilterableOption = (): null => {
    console.log('Not sure how to process filter:', expression);
    return null;
  };

  if (!column) {
    const fieldName = findColumnName(sqlOptions, field);
    const keyTypes = ['project.name', 'created_by.name', 'assigned_to.name'];

    if (fieldName) {
      if (keyTypes.includes(fieldName)) {
        return expressionFormatter(fieldName, 'in', expression);
      }
      return expressionFormatter(fieldName, 'text_contain', expression);
    }

    return reportUnfilterableOption();
  }

  if (column.name === '_status') {
    return statusFormatter(sqlOptions, expression);
  }

  // Anticipating more of these, hence the premature "switch" statement
  switch (column.type) {
    case 'date':
    case 'timestamp':
      return dateFormatter(column, expression);
    case 'array':
    case 'string':
      return stringFormatter(column, expression, sqlOptions);
    default: {
      return reportUnfilterableOption();
    }
  }
}
